import styled, { css } from 'styled-components';
import { Box } from '@bechtel/gds';

export const AddReportContainerStyled = styled(Box).attrs({
  flexDirection: { sm: 'column' },
  px: { sm: '550' },
  py: { sm: '400' },
  mt: { sm: '450' },
  mb: { sm: '450' },
})`
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.16);
  border-left: 0;
  ${({ theme }) =>
    css`
      border: solid 1px ${theme.colors.grey[300]};
      border-left: ${theme.spacings[300]} solid ${theme.colors.bechtel.blue[300]};
      border-radius: ${theme.radii[300]};
    `}
`;
